module.exports = __webpack_public_path__ + "media/images/jobs/jobs-writer-en-4bf7a76bcd698140f7dcbd8716b47330.jpg";